import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/offer';
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-81" data-mp="26yfs1jcmjdn6">
      <div className="mx-auto max-w-4xl" data-id="element-82" data-mp="26xwk8vgou5mv">
        <header className="text-center" data-id="element-83" data-mp="2bxiwp2oozhum">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-84" data-mp="2bw7uh7awai5m">
            ¿Cuántas veces más vas a terminar en discusión?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" style={{
          fontSize: '15px'
        }} data-id="element-85" data-mp="1y042zlreonwu">
            Sos una cuidadora que lo da todo. Pero cada vez que intentás hablar sobre
            algo del cuidado, terminás en una discusión que te agota.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-86" data-mp="1sz6n5ftvc5yi">
            El problema no es tu esfuerzo. Es que te faltaba un método para conversar.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-87" data-mp="3nbmpw6ngh1ym">
          {painPoints.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-88" data-mp="1yzvirhfuantx" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-89" data-mp="23thwlcxqoxrb" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-90" data-mp="1g3wzzr8ny1zk">{point}</p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-91" data-mp="1p30kmznhapg6">
          ¿Y si pudieras conversar sin terminar agotada desde mañana mismo?
        </p>
      </div>
    </section>;
}